import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_5.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/employee');
  const shareText = encodeURIComponent('Cultivating a Learning-First Culture!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Employee Wellbeing — Outstanding Workplaces</title>
        <meta property="og:title" content="Employee Wellbeing — Outstanding Workplaces" />
        <meta property="og:description" content="Employee Wellbeing – Prioritize physical, mental, and emotional health." />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1777896145/i_5_hbttoa.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/employee" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Employee Wellbeing — Outstanding Workplaces" />
        <meta name="twitter:description" content="Employee Wellbeing – Prioritize physical, mental, and emotional health." />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1777896145/i_5_hbttoa.jpg" />
      </Helmet>

        <div className="sight_5_page_wrapper">
      <div className="sight_5_content_container">

        <div className="sight_5_section_one">

          {/* TITLE */}
          <h1 className="sight_5_page_title">
            Employee Wellbeing – Prioritize physical, mental, and emotional health.
          </h1>

          {/* ROW */}
          <div className="sight_5_row">

            {/* LEFT SIDE */}
            <div className="sight_5_left">
              <div className="sight_5_image_wrapper">
                <img
                  src="/assets/i_5.jpg"
                  alt="Team meeting discussion"
                  className="sight_5_blog_image"
                />
              </div>


                {/* SHARE SECTION */}
                <div className="sight_5_share_section">
                  <span className="sight_5_share_text">Share :</span>
                  <div className="sight_5_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_5_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_5_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_5_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_5_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

             <p className="sight_5_intro_paragraph">
                Fostering employee wellbeing goes beyond just physical health. It encompasses mental, emotional, and social wellness, ensuring employees feel supported, motivated, and resilient. Organizations that prioritize wellbeing create a positive workplace culture, reduce burnout, and enhance overall productivity. Initiatives can include wellness programs, mental health resources, flexible work options, and opportunities for personal growth, all contributing to a happier, more engaged workforce.
              </p>
            </div>

            {/* RIGHT SIDE */}
            <div className="sight_5_right">
              <div className="sight_5_ad_card">
                <img src="/assets/bc_1.png" className="sight_5_ad_bg" />
                <div className="sight_5_ad_overlay"></div>

                <img src="/assets/bg_1.png" className="sight_5_ad_badge" />

                <div className="sight_5_ad_content">
                  <h2>
                    Earn the Outstanding <br />
                    <span>Workplaces Certification</span>
                  </h2>

                  <ul>
                    <li>Attract Top Talent</li>
                    <li>Boost Employee Engagement</li>
                    <li>Drive Culture-Led Growth</li>
                  </ul>

                    <button 
  className="sight_5_ad_btn"
  onClick={() => window.location.href = '/nominate'}
>
  Get Certificate
</button>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* SECTION TWO */}
        <div className="sight_5_section">

          <div className="sight_5_topics">

            <div className="sight_5_topic_item">
              <h2 className="sight_5_topic_heading">What Is Employee Wellbeing & Why It Matters</h2>
              <ul className="sight_5_topic_list">
                <li>Explore the definition of employee wellbeing, explain its impact on engagement, productivity, and retention, and outline the holistic wellness framework (physical, mental, social, financial).</li>
              </ul>
            </div>

            <div className="sight_5_topic_item">
              <h2 className="sight_5_topic_heading">Physical Health at Work: Fitness, Nutrition & Movement</h2>
              <ul className="sight_5_topic_list">
                <li>Discuss physical wellbeing initiatives such as fitness programs, standing desks, workplace walking meetings, nutrition education, and preventive care benefits.</li>
              </ul>
            </div>


            <div className="sight_5_topic_item">
              <h2 className="sight_5_topic_heading">Mental Health Awareness: Reducing Stress and Burnout</h2>
              <ul className="sight_5_topic_list">
                <li>Write about the importance of mental health support — stress management workshops, access to counseling (EAPs), mindfulness sessions, and creating stigma‑free environments.</li>
              </ul>
            </div>

            <div className="sight_5_topic_item">
              <h2 className="sight_5_topic_heading">Emotional Wellbeing at Work: Building Resilience</h2>
              <ul className="sight_5_topic_list">
                <li>Cover emotional wellness topics like emotional intelligence, peer support groups, gratitude practices, and activities that help employees understand and manage emotions.</li>
              </ul>
            </div>

            <div className="sight_5_topic_item">
              <h2 className="sight_5_topic_heading">Creating a Supportive Workplace Culture</h2>
              <ul className="sight_5_topic_list">
                <li>Focus on how leadership, recognition, open communication, and strong social connections contribute to emotional and mental wellbeing. Include team‑building events and regular feedback loops.</li>
              </ul>
            </div>

            <div className="sight_5_topic_item">
              <h2 className="sight_5_topic_heading">Work‑Life Balance: Flexible Work & Time Off</h2>
              <ul className="sight_5_topic_list">
                <li>Address flexible schedules, remote/hybrid work options, encouraging breaks and vacation time, and policies that help employees maintain work‑life harmony.</li>
              </ul>
            </div>

            <div className="sight_5_topic_item">
              <h2 className="sight_5_topic_heading">Employee Wellbeing Programs That Work</h2>
              <ul className="sight_5_topic_list">
                <li>Share real‑world examples of successful wellbeing initiatives (yoga sessions, walking groups, wellness bonuses) and advice on getting buy‑in from leadership.</li>
              </ul>
            </div>

            <div className="sight_5_topic_item">
              <h2 className="sight_5_topic_heading">Mental Wellness Tools & Resources</h2>
              <ul className="sight_5_topic_list">
                <li>Create a curated list of tools — meditation apps, mindfulness resources, self‑care techniques, stress‑reduction exercises — that employees can use daily.</li>
              </ul>
            </div>

            <div className="sight_5_topic_item">
              <h2 className="sight_5_topic_heading">Healthy Eating & Lifestyle Practices at Work</h2>
              <ul className="sight_5_topic_list">
                <li>Discuss how nutrition affects wellbeing — healthy cafeteria options, snacks, hydration stations, workshops on healthy eating — and the link with energy and mood.</li>
              </ul>
            </div>


            <div className="sight_5_topic_item">
              <h2 className="sight_5_topic_heading">Measuring & Improving Workplace Wellbeing</h2>
              <ul className="sight_5_topic_list">
                <li>Guide HR and leaders on tracking wellbeing using surveys, engagement metrics, health outcomes, and how to adapt programs based on employee feedback.</li>
              </ul>
            </div>

          </div>
        </div>

       </div>
   </div>
    </>
  );
}

export default BlogPage;
